import React, { useEffect, useState } from "react";
import { motion ,useAnimation } from "framer-motion";
import styled from "styled-components";
import { ReactComponent as ZoomIn}  from "../../assets/images/zoomIn.svg";

import "./index.scss";

const ImageContainer = styled(motion.div)`
  position: relative;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const OptionImage = ({ title, hasAnswered, timeLeft, isCorrect, onClick ,onChangeModal,link}) => {
  const controls = useAnimation()
  const [chooseStyle,setChooseStyle] = useState('')
  const getStatus = () => {
    // if (!hasAnswered) return null;
    if(!hasAnswered && Math.floor(timeLeft) <= 3)return "img-timeOut";
    if(hasAnswered){
      if(isCorrect){
        return "img-success"
      }else{
        return "img-error"
      }
    }
    // return Math.floor(timeLeft) == 0
    //   ? "img-timeOut"
    //   : isCorrect
    //   ? "img-success"
    //   : "img-error";
  };
  useEffect(()=>{
    if (hasAnswered) {
      const _temp = getStatus();
      setChooseStyle(_temp);
    } else {
      if (Math.floor(timeLeft) <= 3) {
        setChooseStyle("img-timeOut");
      } else {
        setChooseStyle("");
      }
    }
  },[timeLeft,hasAnswered])
  useEffect(()=>{
    if(!hasAnswered && Math.floor(timeLeft) % 4 == 1){
      controls.start({
        x: [-5, 5, -5, 5, 0], // 定义一个抖动路径，从左到右然后回到原位
        transition: {
          duration: 0.2, // 每次移动的持续时间
          repeat: 1, // 无限重复
          repeatType: 'reverse', // 重复时反向播放，形成来回抖动的效果
          ease: 'easeInOut' // 缓动函数，使得动画更平滑
        }
      });
    }else{
      controls.stop()
    }
  },[timeLeft])
  return (
    <ImageContainer
      $disabled={hasAnswered}
      className={`option-image-wraper`}

      onClick={() => !hasAnswered && onClick(isCorrect)}
      whileHover={!hasAnswered ? { scale: 1.02 } : {}}
      animate={{
        scale: hasAnswered ? (isCorrect ? 1.03 : 0.97) : 1,
        opacity: hasAnswered && !isCorrect ? 0.6 : 1,
      }}
      transition={{ type: "spring", stiffness: 300 }}
    >
      <motion.div animate={controls} className="option-image-control">
        <img src={`https://news${process.env.NODE_ENV == 'production'?'':"test"}.cgtn.com/event/2025/ai-or-not/song-painting/images/masks/${link}.png`} style={{ filter:`${hasAnswered && !isCorrect? "grayscale(70%)" :'none'}`}} className={`${chooseStyle}`} />
        <div style={{textAlign:'center',marginTop:"20px"}}className="option-image-name">
          {
            hasAnswered && isCorrect? title : hasAnswered && !isCorrect?"AI-generated":null
          }
        </div>
        <div></div>
      </motion.div>
      {hasAnswered && isCorrect ? (
        <div className="mask">
          {/* <img src={zoomIn}  onClick={onChangeModal} style={{cursor:'pointer'}}/> */}
          <ZoomIn onClick={onChangeModal} style={{cursor:'pointer'}}/>
        </div>
      ) : null}
    </ImageContainer>
  );
};

export default OptionImage;
